import { translations as en } from '../i18n/en.js';

const languages = [

    { label: 'Deutsch'                      },
    { label: 'English',    translations: en },
    // { label: 'Nederlands', translations: {} }

];

export const translate = ( e, context ) => {

    const langIndex = Number( window.appLanguage );

    if ( ! langIndex ) {

        return e;

    }

    if ( languages.length <= langIndex ) {

        console.log( '%cSelected user language (' + langIndex + ') not found.', 'color: red; font-weight: bold' );

        return e;

    }

    const translations = languages[ langIndex ].translations;

    if ( ! ( e in translations ) ) {

        console.log( '%cTranslation missing', 'color: red; font-weight: bold', e, context );

        return e;

    }

    const translation = translations[ e ];

    if ( context ) {

        if ( translation === null || typeof translation !== 'object' || ! ( context in translation ) ) {

            console.log( '%cTranslation context missing', 'color: red', e, context );

            return e;

        }

        return translation[ context ];

    }

    return translation;

};

export const getLanguages = () => languages;